import React from 'react';
import {changeToSlug} from '@helper/string.helper';
import LoadingDetailLink from './LoadingDetailLink';

export default function LinkSpecialtyDetail({department = {}, children}) {
    const nameSlug = changeToSlug(department.department_name);
    const slug = nameSlug && department.department_id ? `${nameSlug}-s${department.department_id}` : '';

    return <LoadingDetailLink href={slug ? `/${slug}` : ''}>{children}</LoadingDetailLink>;
}
